import eventManager from 'common/services/-RFC.eventManager';
import { AppInstancesRepository } from 'common/repositories/index';

/**
 * Listen events for App Instances Model
 */
angular.module('listeners')
    .service('AppInstancesListener', () => {

        eventManager.subscribe('socket:app-instances', (response) => {

            if (response.verb === 'POST') {

                AppInstancesRepository.add(response.payload.data);

            }

            if (response.verb === 'PUT') {

                AppInstancesRepository.update(response.payload.data);

            }

            if (response.verb === 'DELETE') {

                AppInstancesRepository.remove(response.payload.data.id);

            }

        });

    });



// WEBPACK FOOTER //
// ./scripts/common/listeners/appInstances.js